import { CurrencyAPI } from '@business/api/currency_api';
import { CompanyId } from '@business/entities/companies';
import { CurrencyID, CurrencyResponse } from '@business/entities/currency';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class CurrencyBloc extends BaseBloc {
  private readonly currencyRepo = new Repository<CurrencyResponse>({
    getItemId: currency => currency.id,
  });

  readonly currencies$ = this.currencyRepo.items$;

  onReset() {
    this.currencyRepo.reset();
  }

  fetchCurrencies = () => {
    return CurrencyAPI.fetchCurrencies().pipe(this.currencyRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_currency_error') }));
  };

  syncCurrency = () => {
    return CurrencyAPI.syncCurrencies().pipe(this.currencyRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_currency_error') }));
  };

  createCurrency = (companyId: CompanyId, data: Partial<CurrencyResponse>) => {
    return CurrencyAPI.createCurrency(companyId, data).pipe(
      this.currencyRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_category'),
      }),
    );
  };

  updateCurrency = (currencyId: CurrencyID, rate: number) => {
    return CurrencyAPI.updateCurrency(currencyId, rate).pipe(
      handleMessage({
        type: requestMessage('create_category'),
      }),
    );
  };

  deleteCurrency = (id: CurrencyID) => {
    return showDeleteConfirmation('Delete Currency', `Do you really want to remove this currency?`).pipe(
      switchMap(() => CurrencyAPI.deleetCurrency(id)),
      this.currencyRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_category'),
      }),
    );
  };
}
